import { Chip, colors } from "@itandi/itandi-bb-ui";
import type React from "react";
import type { DealEstimationHeader } from "~/models/DealEstimationHeader";
import {
	statusBackgroundColors,
	statusLabel
} from "~/models/DealEstimationHeader";
import { formatDate } from "~/utils/DateUtil";

type Props = {
	dealEstimationHeader: DealEstimationHeader;
	ownManagement?: boolean;
};

export const DealEstimationHeaderStatus: React.FC<Props> = ({
	dealEstimationHeader,
	ownManagement = false
}: Props) => {
	const { status } = dealEstimationHeader;
	// https://itandi-dev.atlassian.net/browse/NSKDEV-1631で対応
	if (ownManagement || status === "draft" || status === "accepted_by_system")
		return null;
	return (
		<>
			<Chip
				background={statusBackgroundColors(status)}
				borderColor={null}
				label={statusLabel(status)}
				maxWidth="100%"
				textColor={colors["itandi-white"]}
			/>
			{status !== "request" && (
				<p>
					処理日時：
					{formatDate(dealEstimationHeader?.processedAt, true)}
				</p>
			)}
		</>
	);
};
